import { API_BASE_URL, API_PATHS,getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class NoticeService {

static getNotice(item) {
   
     const user = JSON.parse(localStorage.getItem("user"));
  const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
         
 let api = `${API_BASE_URL}${dynamicPaths.getNotice}?limit=${item?.limit || 25}&page=${item?.page || 1}`;
     const params = new URLSearchParams();
   if(item?.id) params.append("id", item.id);
     if(item?.usertype) params.append("usertype", item.usertype);
    if ([...params].length > 0) {
    api += `?${params.toString()}`;
  }
    return axiosInstance
        .get(api,item)
}

static addNotice(data) {
  let api = '';
    api = `${API_BASE_URL}${API_PATHS.addNotice}`;
    return axiosInstance
        .post(api,data)

}

static editNotice(data) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editNotice}`;
    return axiosInstance
        .put(api,data)
        
}
 
static deleteNotice(id) {
  let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteNotice}?id=${id}`;
    
    return axiosInstance
        .delete(api)
}


}

export default NoticeService;
